module.exports = __webpack_public_path__ + "static/media/UTMcGovernTexas.d344bda1.png";